<template>
  <CBox>
    <OmtTypography
      v-show="!!question.text"
      as="h2-bold"
      mb="16px"
    >
      {{ question.text }}
    </OmtTypography>

    <AuditRadioGroup
      v-if="question.options"
      hasDivider
      :values="question.options"
      :value.sync="selectedRadio"
      customValueKey="id"
    />
  </CBox>
</template>

<script>
import AuditRadioGroup from "./AuditRadioGroup.vue";

export default {
  components: {
    AuditRadioGroup
  },
  props: {
    question: {
      type: Object,
      default: () => ({
        text: "",
        options: []
      })
    }
  },
  data() {
    return {
      selectedRadio: null
    };
  },
  watch: {
    selectedRadio(val) {
      this.$emit("change", val);
    }
  }
};
</script>
